<section class="h-100">
  <div class="container-fluid h-100">
    <div class="row justify-content-end ">
      <div class="col-8 pe-0 ">
        <div class="card h-100">
          <div class="card-body">
            <div  [routerLink]="['/login']" class="mx-auto mb-4 logo"></div>
            <h3 class="text-center mt-1 fw-bold">Activación de usuario</h3>
            <div class="text-center mb-2">Por favor rellena los siguientes campos para activar correctamente tu
              usuario
            </div>
            <form class=" d-flex flex-column  align-items-center w-100 h-75"
                  [formGroup]="activarForm">
              <mat-stepper #stepper class="col-10 h-100" linear formArrayName="account">
                <mat-step  formGroupName="0"   [stepControl]="userForm">

                    <div class="row w-100">
                      <div class="col-5 p-0 mb-2 me-5">
                        <label for="name" class="form-label">Nombre</label>
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          formControlName="name"
                          placeholder="Juan Alejandro"

                          readonly
                        />
                        <div *ngIf="invalidName" class="invalid-message">Por favor, ingrese su nombre</div>
                      </div>
                      <div class="col-5 p-0 mb-2">
                        <label for="lastnames" class="form-label">Apellido</label>
                        <input
                          type="text"
                          class="form-control"
                          id="lastnames"
                          formControlName="lastnames"
                          placeholder="Perez Gonzales"
                           readonly   />
                        <div *ngIf="invalidLastnames" class="invalid-message">Por favor, ingrese su apellido</div>
                      </div>
                    </div>
                    <div class="row w-100">
                      <div class="col-5 p-0">
                        <label for="phone" class="form-label">Teléfono usuario</label>
                        <input
                          type="text"
                          class="form-control"
                          id="phone"
                          formControlName="phone"
                          placeholder="+56973458564"/>
                        <div *ngIf="invalidPhone" class="invalid-message">Por favor ingrese un teléfono valido, el cual
                          debe incluir el +56 antes de su numero de teléfono</div>
                      </div>
                    </div>
                    <div class="row d-flex mt-5 pt-5">
                      <button (click)="cancel()" class="btn btn-secondary  col-5 me-5 mt-5">Cancelar</button>
                      <button [disabled]="userForm.invalid"  matStepperNext class="btn btn-primary col-5 mt-5">Continuar
                      </button>
                    </div>
                </mat-step>
                <mat-step formGroupName="1" [stepControl]="empresaForm">
                  <div class="row w-100">
                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="empresa" class="form-label">Empresa</label>
                      <input
                        type="text"
                        class="form-control"
                        id="empresa"
                        formControlName="name"
                        placeholder="Empresa"
                        readonly/>
                    </div>
                    <div class="col-5 p-0 mb-2">
                      <label for="rutempresa" class="form-label">Rut empresa</label>
                      <input
                        [value]="empresaForm.get('rut').value | rut"
                        type="text"
                        class="form-control"
                        id="rutempresa"
                        formControlName="rut"
                        placeholder="76.494.343-9"
                        appFormatRut
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="city" class="form-label">Comuna</label>
                      <input
                        type="text"
                        class="form-control"
                        id="city"
                        formControlName="city"
                        placeholder="Santiago"/>
                      <div *ngIf="invalidCity" class="invalid-message">Por favor ingrese una comuna</div>
                    </div>
                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="address" class="form-label">Dirección</label>
                      <input
                        type="text"
                        class="form-control"
                        id="address"
                        formControlName="address"
                        placeholder="Las Magnolias 19"/>
                      <div *ngIf="invalidAddress" class="invalid-message">Por favor ingrese una dirección</div>
                    </div>

                  </div>
                  <div class="row d-flex mt-5 pt-5">
                    <button (click)="cancel()" class="btn btn-secondary  col-5 me-5 mt-5">Cancelar</button>
                    <button [disabled]="empresaForm.invalid" matStepperNext class="btn btn-primary col-5 mt-5">Continuar
                    </button>
                  </div>
                </mat-step>
                <mat-step formGroupName="2" [stepControl]="credencialesForm">
                  <div class="row w-100">
                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="user" class="form-label">Usuario</label>
                      <input
                        type="text"
                        class="form-control"
                        id="user"
                        formControlName="username"
                        placeholder="JPerez"
                        readonly/>
                    </div>

                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="email" class="form-label">Correo electrónico</label>
                      <input
                        type="text"
                        class="form-control"
                        id="email"
                        formControlName="email"
                        placeholder="nombre@correoelectronico.com"/>
                      <div *ngIf="invalidEmail" class="invalid-message">Por favor ingrese un Correo electrónico valido
                      </div>
                    </div>
                  </div>
                  <div class="row w-100">
                    <div class="col-5 p-0 mb-2 me-5">
                      <label for="password" class="form-label">Contraseña</label>
                      <div class="input-group prefix mb-3">
                      <span
                        (click)=" showPassword = !showPassword"
                        [ngClass]="{'icon-login_password_hidden':!showPassword,
                        'icon-login_password_visible':showPassword}"
                        class="input-group-icon start
                      text-center
                      text-primary
                      mt-3"></span>
                        <input
                          [type]="showPassword ? 'text': 'password'"
                          class="form-control"
                          id="password"
                          formControlName="password"
                          placeholder="Contraseña"
                        />
                        <div *ngIf=" invalidPassword && passwordErrors" class="invalid-message">
                          <ng-container *ngIf="passwordErrors.minL">
                            La contraseña debe tener mínimo {{passwordErrors.minL.minlength?.requiredLength}}
                            caracteres.
                            <br>
                          </ng-container>
                          <ng-container *ngIf="passwordErrors.maxL">
                            La contraseña debe tener maximo {{passwordErrors.maxL.maxlength?.requiredLength}}
                            caracteres.<br>
                          </ng-container>
                          <ng-container *ngIf="!passwordErrors.minL && !passwordErrors.maxL && passwordErrors.pattern">
                            La contraseña debe tener 2 de las 3 siguientes condiciones:<br>
                            • mayúsculas y minúsculas<br>
                            • dígitos <br>
                            • carácter especial<br>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    <div class="col-5 p-0 mb-2">
                      <label for="confirmPassword" class="form-label"> Confirmar Contraseña</label>
                      <div class="input-group prefix mb-3">
                      <span (click)=" showPassword = !showPassword"
                            [ngClass]="{'icon-login_password_hidden':!showPassword,
                        'icon-login_password_visible':showPassword}"
                            class="input-group-icon start
                      text-center
                      text-primary
                      mt-3"></span>

                        <input
                          [type]="showPassword ? 'text': 'password'"
                          class="form-control"
                          id="confirmPassword"
                          formControlName="confirm"
                          placeholder="Contraseña"/>
                        <div *ngIf=" invalidConfirmPassword && confirmPasswordErrors" class="invalid-message">
                          <ng-container *ngIf="confirmPasswordErrors.same && password.value">
                            Las contraseñas deben ser iguales<br>
                          </ng-container>
                          <ng-container *ngIf="confirmPasswordErrors.minL">
                            La contraseña debe tener mínimo {{confirmPasswordErrors.minL.minlength?.requiredLength}}
                            caracteres. <br>
                          </ng-container>
                          <ng-container *ngIf="confirmPasswordErrors.maxL">
                            La contraseña debe tener maximo {{confirmPasswordErrors.maxL.maxlength?.requiredLength}}
                            caracteres.<br>
                          </ng-container>
                          <ng-container
                            *ngIf="!confirmPasswordErrors.minL && !confirmPasswordErrors.maxL &&confirmPasswordErrors.pattern">
                            La contraseña debe tener 2 de las 3 siguientes condiciones:<br>
                            • mayúsculas y minúsculas<br>
                            • dígitos <br>
                            • carácter especial<br>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row d-flex mt-5 pt-5">
                    <button (click)="cancel()" class="btn btn-secondary  col-5 me-5 mt-5">Cancelar</button>
                    <button [disabled]="activarForm.invalid" (click)="submit()" class="btn btn-primary col-5 mt-5" type="submit">Activar
                    </button>
                  </div>
                </mat-step>
              </mat-stepper>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

